import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import LABELS from "../../../../constants/labels/motor.labels";
import SwitchButton from "../../../common/switch-button";
import Dropdown from "../../../common/dropdown";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";

const FluidVelocity = () => {
    const { fluidVelocityCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { fluidVelocity, ShroudODList, ShroudWTList, FluidVelocityPostMotor } = useAppSelector(state => state?.motor);
    const { updateFluidVelocityCollapse } = useCollapseFacade();
    const { updateShroudODRequired, updateShroudOD, updateShroudWeight } = useTubingFacade();

    const { tab1Input } = useAppSelector(state => state?.tubing);

    const handleToggleButton = (checked: boolean) => {
        if (checked)
            updateShroudODRequired('1');
        else {
            updateShroudWeight("");
            updateShroudOD("");
            updateShroudODRequired('0');
        }
    };

    const handleCollapseChange = (key: boolean) => {
        updateFluidVelocityCollapse(key);
    };

    const handleShroudOD = (option: any) => {
        updateShroudOD(option?.id || "");
    };

    const handleShroudWeight = (option: any) => {
        updateShroudWeight(option?.id || "");
    };
    return (
        <Accordion
            tooltipText="Formulas"
            title="Fluid velocity check"
            isOpen={fluidVelocityCollapse}
            link={'/help?tab=Motor#FluidVel'}
            onToggle={() => handleCollapseChange(!fluidVelocityCollapse)}
            content={
                <>
                    <div className="flex justify-center items-start p-2 gap-4 w-full">
                        <div className="flex flex-col justify-between items-center w-full">
                            <div className="flex w-full">
                                <label className="text-neutral-25 text-[18px] font-normal">
                                    {LABELS.FluidVelocityPostMotor}
                                </label>
                                <label className="text-neutral-25 text-[12px] font-normal mt-2 ml-1">
                                    <span className="text-success-600 border border-success-600 px-3 py-1 rounded-md">
                                        {fluidVelocity} {LABELS.ftPerSec}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center items-start p-2 w-full">
                        <div className="flex flex-col border-[1px] border-darkcolor-400 rounded-[8px] justify-between items-center w-full">
                        </div>
                    </div>
                    <div className="flex justify-center items-start p-2 w-full">
                        <div className="flex flex-col justify-between  w-full">
                            <SwitchButton
                                checked={tab1Input?.hiddenWthrMotrShrd === '1'}
                                onChange={handleToggleButton}
                                label={"Shroud required"}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {tab1Input?.hiddenWthrMotrShrd === '1' && (
                        <div className="flex justify-center items-start p-4 gap-4 w-full">
                            <div className="flex flex-col justify-between items-center w-1/2 align-top">
                                <div className=" justify-between items-center w-full">
                                    <Dropdown
                                        label="Shroud OD"
                                        showSelectOption={true}
                                        options={ShroudODList}
                                        onSelect={(option) => handleShroudOD(option)}
                                        dropdownBgColor="bg-darkcolor-800"
                                        bgColor="bg-transparent"
                                        selected={tab1Input?.hiddenMotrShrdOD} />
                                </div>
                            </div>
                            <div className="flex flex-col justify-between items-center w-1/2 align-top">
                                <div className=" justify-between items-center w-full">
                                    <Dropdown
                                        label="Shroud Weight"
                                        options={ShroudWTList}
                                        showSelectOption={true}
                                        onSelect={(option) => handleShroudWeight(option)}
                                        dropdownBgColor="bg-darkcolor-800"
                                        bgColor="bg-transparent"
                                        selected={tab1Input?.hiddenMotrShrdWght} />
                                </div>
                            </div>
                        </div>
                    )}
                    {tab1Input?.hiddenWthrMotrShrd === '1' && (
                        <div className="flex justify-center items-start p-2 w-full">
                            <div className="flex flex-col justify-between  w-full">
                                <label className="text-neutral-25 text-[14px] font-normal">
                                    {LABELS.FluidVelocityPostMotor}: {FluidVelocityPostMotor} {LABELS.ftPerSec}
                                </label>
                            </div>
                        </div>
                    )}
                </>
            }
        />
    );
};

export default FluidVelocity;


